import {
    GET_SNOWFLAKE_CONFIGURATION,
    SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION,
    SET_SNOWFLAKE_USER_CREDENTIALS,
    type SetSnowflakeServiceAccountConfiguration,
    type SetSnowflakeUserCredentials
} from 'app/lib/types/server';
import type {
    GetSnowflakeConfigurationTypeMap,
    SetSnowflakeServiceAccountConfigurationTypeMap,
    SetSnowflakeUserCredentialsTypeMap
} from 'app/lib/types/cqrs';
import type { ReduxActionOutcome, ReduxApiAction, ReduxNonApiAction } from 'app/store/storeTypes';
import {
    GET_SNOWFLAKE_CONFIGURATION_ACTION_TYPE,
    SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_ACTION_TYPE,
    SET_SNOWFLAKE_USER_CREDENTIALS_ACTION_TYPE,
    TOGGLE_CONNECTION_STATUS_DIALOG
} from './types';

export const doToggleConnectionStatusModal = (isOpen: boolean) =>
    ({
        type: TOGGLE_CONNECTION_STATUS_DIALOG,
        payload: { isOpen }
    }) as const satisfies ReduxNonApiAction;

export const doGetSnowflakeConfiguration = () =>
    ({
        type: GET_SNOWFLAKE_CONFIGURATION_ACTION_TYPE,
        api: { version: 2, name: GET_SNOWFLAKE_CONFIGURATION }
    }) as const satisfies ReduxApiAction<GetSnowflakeConfigurationTypeMap>;

export const doSetSnowflakeServiceAccountConfiguration = (
    account: string,
    credentials: SetSnowflakeServiceAccountConfiguration['credentials']
) =>
    ({
        type: SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_ACTION_TYPE,
        api: { version: 2, name: SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION },
        params: {
            _kind: SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION,
            account,
            credentials
        },
        onSucceeded: ({ dispatch }) => {
            dispatch(doGetSnowflakeConfiguration());
        }
    }) as const satisfies ReduxApiAction<SetSnowflakeServiceAccountConfigurationTypeMap>;

export const doSetSnowflakeUserCredentials = (
    credentials: SetSnowflakeUserCredentials['credentials']
) =>
    ({
        type: SET_SNOWFLAKE_USER_CREDENTIALS_ACTION_TYPE,
        api: { version: 2, name: SET_SNOWFLAKE_USER_CREDENTIALS },
        params: {
            _kind: SET_SNOWFLAKE_USER_CREDENTIALS,
            credentials
        }
    }) as const satisfies ReduxApiAction<SetSnowflakeUserCredentialsTypeMap>;

export type SnowflakeConfigurationActionOutcomes =
    | ReduxActionOutcome<
          ReturnType<typeof doGetSnowflakeConfiguration>,
          GetSnowflakeConfigurationTypeMap
      >
    | ReduxActionOutcome<
          ReturnType<typeof doSetSnowflakeServiceAccountConfiguration>,
          SetSnowflakeServiceAccountConfigurationTypeMap
      >
    | ReduxActionOutcome<
          ReturnType<typeof doSetSnowflakeUserCredentials>,
          SetSnowflakeUserCredentialsTypeMap
      >
    | ReduxActionOutcome<ReturnType<typeof doToggleConnectionStatusModal>>;
